module.exports = __webpack_public_path__ + "static/media/office-computer-equipment.57e422de.svg";